import { surface } from "./foundation";
export const Input = surface("input", "input", "cyra-input");
